export default (theme) => ({
    root: {
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
    section: {},
    container: {
        display: 'flex',
        padding: 20,
    },
    carousel: {
        display: 'flex',
    },
    dropZone: {
        display: 'flex',
        width: 175,
        height: 60,
        '&:focus': {
            outline: 'none',
        },
    },
    dropZoneActive: {
        display: 'flex',
        width: '100%',
        height: '100%',
        borderRadius: 4,
        border: `2px solid ${theme.colors.semantic.info500}`,
        backgroundColor: theme.colors.semantic.info150,
        '& $dropText': {
            color: theme.colors.primary.white,
            background: theme.colors.semantic.info500,
            marginTop: 40,
        },
    },
    dropZoneInactive: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
        border: `1px dashed ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.grey[50],
        '& $dropText': {
            color: theme.colors.utility.textSecondary,
        },
    },
    dropText: {
        display: 'block',
        textAlign: 'center',
        lineHeight: '20px',
        width: '100%',
    },
    cloudUploadIcon: {
        marginBottom: 2,
    },
    deleteModalOverlay: {
        zIndex: 1300,
    },
    loader: {
        margin: 'auto 20px auto 0',
    },
});
